import Adyen from './Adyen';

export default Adyen;
